import { ApplicationEntity } from "@/model/entity/application-entity"
import { FieldDescriptor, FieldTypeEnum } from "@/model/entity//field-descriptor"

export class MasterRange extends ApplicationEntity {
  @FieldDescriptor({ fieldType: FieldTypeEnum.BOOLEAN, fieldPrettyName: "entity.range.active" })
  active: boolean
  @FieldDescriptor({ fieldType: FieldTypeEnum.NUMBER, fieldPrettyName: "entity.range.start", isFilterable: true })
  rangeStart: number
  @FieldDescriptor({ fieldType: FieldTypeEnum.NUMBER, fieldPrettyName: "entity.range.end" })
  rangeEnd: number
  @FieldDescriptor({ fieldType: FieldTypeEnum.NUMBER, fieldPrettyName: "entity.range.next" })
  rangeNext: number
  @FieldDescriptor({ fieldType: FieldTypeEnum.DATE, fieldPrettyName: "entity.range.date" })
  insertDate: Date
  @FieldDescriptor({ fieldType: FieldTypeEnum.NUMBER, fieldPrettyName: "entity.range.available" })
  available: number

  constructor(
    active: boolean,
    rangeStart: number,
    rangeEnd: number,
    rangeNext: number,
    insertDate: Date,
    id?: number
  ) {
    super(id)
    this.active = active
    this.rangeStart = rangeStart
    this.rangeEnd = rangeEnd
    this.rangeNext = rangeNext
    this.insertDate = insertDate
    this.available = rangeEnd - rangeNext
  }
}
